<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section">

    <form [formGroup]="textEditForm" class="m-1">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="text-widget-name">
      </mat-form-field>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.title' | translate}}</mat-label>
              <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}" data-nar="text-widget-title">
            </mat-form-field>
          </div>
        </div>
        <div class="ps-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.subtitle' | translate}}</mat-label>
              <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}" data-nar="text-widget-subtitle">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- WYSWIG EDITOR -->
      <div id="toolbar">
        <div class="d-flex justify-content-between">
          <div class="ql-default-buttons">
            <button class="ql-bold" matTooltip="{{'pass.bold' | translate}}"></button>
            <button class="ql-italic" matTooltip="{{'pass.italic' | translate}}"></button>
            <button class="ql-link" matTooltip="{{'pass.link-URL' | translate}}"></button>
            <button
              class="ql-custom-link-target"
              matSuffix
              [matMenuTriggerFor]="editorLinkMenu"
              matTooltip="{{ 'pick_link_target' | translate }}"
              [disabled]="translationModeOriginal"
              >
              <mat-icon class="material-symbols-outlined">anchor</mat-icon>
            </button>
            <button class="ql-list" value="ordered" matTooltip="{{'pass.ordered_list' | translate}}"></button>
            <button class="ql-list" value="bullet" matTooltip="{{'pass.bullet_list' | translate}}"></button>
            <button class="ql-clean" matTooltip="{{'pass.clean' | translate}}"></button>
          </div>
          @if (schemaKeys.length > 0 || payloadKeys.length > 0) {
            <button type="button" class="payload-key-trigger" matSuffix style="cursor: pointer;" matTooltip="{{'pass.addPayloadKey' | translate}}" id="custom-button" [matMenuTriggerFor]="payloadKeyMenu" [disabled]="translationModeOriginal">
              <mat-icon>data_object</mat-icon>
            </button>
          }
        </div>
      </div>

      <!-- Quill Editor -->
      <quill-editor #editor formControlName="text" class="mb-4 w-100"
        [ngClass]="getLanguageClass()" id="text" [modules]="quillModules" placeholder="{{'insertText' | translate}}"
        [styles]="{ height: '280px', width: '100%' }"
        (onEditorCreated)="onEditorCreated($event)" [sanitize]="false">
      </quill-editor>

      <mat-menu #payloadKeyMenu="matMenu">
        <button mat-menu-item disabled>{{'pass.widgets.insert_payload_key' | translate}}</button>
        <mat-divider></mat-divider>
        @if (schemaMenuNodes.length > 0) {
          <button mat-menu-item [matMenuTriggerFor]="schemaKeyMenu" [disabled]="translationModeOriginal">{{"pass.widgets.pasteFromDataStructure" | translate}}</button>
        }
        @if (payloadTemplateMenuNodes.length > 0) {
          <button mat-menu-item [matMenuTriggerFor]="workTaskPayloadKeyMenu" [disabled]="translationModeOriginal">{{"pass.widgets.pasteFromTemplate" | translate}}</button>
        }
      </mat-menu>
      <mat-menu #schemaKeyMenu="matMenu">
        @for (node of schemaMenuNodes; track node.path) {
          @if (node.children.length > 0) {
            <button mat-menu-item [matMenuTriggerFor]="schemaBranchMenuFor(node)" [disabled]="translationModeOriginal">{{ node.key }}</button>
          } @else {
            <button mat-menu-item (click)="addPayloadKeyAtCursor(node.path)" [disabled]="translationModeOriginal">{{ node.key }}</button>
          }
        }
      </mat-menu>
      @for (branch of schemaBranchNodes; track branch.path) {
        <mat-menu #schemaBranchMenu="matMenu">
          @for (node of branch.children; track node.path) {
            @if (node.children.length > 0) {
              <button mat-menu-item [matMenuTriggerFor]="schemaBranchMenuFor(node)" [disabled]="translationModeOriginal">{{ node.key }}</button>
            } @else {
              <button mat-menu-item (click)="addPayloadKeyAtCursor(node.path)" [disabled]="translationModeOriginal">{{ node.key }}</button>
            }
          }
        </mat-menu>
      }
      <mat-menu #workTaskPayloadKeyMenu="matMenu">
        @for (template of payloadTemplateMenuNodes; track template.title) {
          <button mat-menu-item [matMenuTriggerFor]="workTaskTemplatePayloadKeyMenu" [matMenuTriggerData]="{ keys: template.keys }" [disabled]="translationModeOriginal">{{ template.title }}</button>
        }
      </mat-menu>
      <mat-menu #workTaskTemplatePayloadKeyMenu="matMenu">
        <ng-template matMenuContent let-keys="keys">
          @for (key of keys; track key) {
            <button  mat-menu-item (click)="addPayloadKeyAtCursor(key)" [disabled]="translationModeOriginal"> {{ key }} </button>
          }
        </ng-template>
      </mat-menu>
      <mat-menu #editorLinkMenu="matMenu">
        <ng-template matMenuContent>
          @if (anchorOptions?.length) {
            <button
              mat-menu-item
              disabled>
              {{ 'widgets' | translate }}
            </button>
          }
          @for (a of anchorOptions; track a.id) {
            <button
              mat-menu-item
              (click)="applyEditorLink(buildAnchorUrl(a))">
              <span>{{ a.label || a.name || a.id }}</span>
            </button>
          }
          @if (anchorOptions?.length && childPages?.length) {
            <mat-divider></mat-divider>
          }
          @if (childPages?.length) {
            <button
              mat-menu-item
              disabled>
              {{ 'pass.childTabLabels' | translate }}
            </button>
          }
          @for (c of childPages; track c.id) {
            <button
              mat-menu-item
              (click)="applyEditorLink(buildChildPageUrl(c))">
              <span>{{ c.name || c.id }}</span>
            </button>
          }
        </ng-template>
      </mat-menu>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label data-nar="text-widget-alignment">{{'pass.textAlignment' | translate}}</mat-label>
              <mat-select formControlName="textAlignment" class="input-group">
                <mat-option value="right"><mat-icon>format_align_right</mat-icon>{{'pass.right' | translate}}</mat-option>
                <mat-option value="left"><mat-icon>format_align_left</mat-icon>{{'pass.left' | translate}}</mat-option>
                @if (!textEditForm.value.image || !textEditForm.value.imageUrl) {
                  <mat-option value="center"><mat-icon>format_align_center</mat-icon>{{'pass.center' | translate}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="ps-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field  appearance="outline" class="w-100">
              <mat-label>{{'pass.imagePosition' | translate}}</mat-label>
              <mat-select formControlName="imagePosition" class="input-group">
                <mat-option value="left">
                  <mat-icon class="material-symbols-outlined">format_image_left</mat-icon> {{'pass.left' | translate}}
                </mat-option>
                <mat-option value="right">
                  <mat-icon class="material-symbols-outlined">format_image_right</mat-icon> {{'pass.right' | translate}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>


      <mat-expansion-panel class="mt-1 mb-4" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title style="color:#595c5f;">
            <mat-icon class="material-symbols-outlined">image</mat-icon> <span class="px-2">{{'pass.widgets.img' | translate}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="py-3">
          @if (urlData || dragFileData.enterUrl || dynamicUrl) {
            <div class="mt-2">
              <div class="d-flex justify-content-stretch">
                @if (urlData) {
                  <div class="custom-form-field">
                    <img [src]="urlData"  height="150" style="object-fit: cover; border-radius:10px; width:100%;" onerror="this.src='./../../assets/img/default.jpg'" >
                  </div>
                }
                @if (!urlData) {
                  <div class="custom-form-field" [ngStyle]="{'background-image': 'url( ./../../assets/img/default.jpg)'}"></div>
                }
                <div class="form-fields ps-2">
                  <div class="d-flex align-items-center">
                    <mat-form-field appearance="outline" class="flex-grow-1">
                      <mat-label>{{ 'pass.url' | translate }}</mat-label>
                      <input type="text" formControlName="imageUrl" matInput (change)="checkNewUrl()" data-nar="text-widget-image-source">
                      @if (textEditForm.controls['imageUrl']?.hasError('invalidCharacters')) {
                        <mat-error>
                          {{ 'invalid_characters' | translate }}
                        </mat-error>
                      }
                      @if (textEditForm.controls['imageUrl']?.hasError('pattern') && !textEditForm.controls['imageUrl']?.hasError('invalidCharacters')) {
                        <mat-error>
                          {{ 'url_pattern_invalid' | translate }}
                        </mat-error>
                      }
                      <button mat-icon-button matSuffix (click)="deleteImg(url)" class="delete-button"
                        matTooltip="{{ 'pass.deleteIMG' | translate }}" [disabled]="translationModeOriginal || checkDisabledField('imageUrl')">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <mat-form-field appearance="outline" class="flex-grow-1 w-100">
                    <mat-label>{{ 'pass.fallbackUrl' | translate }}</mat-label>
                    <input type="text" formControlName="imageFallbackUrl" matInput data-nar="text-widget-image-fallback">
                    @if (textEditForm.controls['imageFallbackUrl']?.hasError('invalidCharacters')) {
                      <mat-error>
                        {{ 'invalid_characters' | translate }}
                      </mat-error>
                    }
                    @if (textEditForm.controls['imageFallbackUrl']?.hasError('pattern') && !textEditForm.controls['imageFallbackUrl']?.hasError('invalidCharacters')) {
                      <mat-error>
                        {{ 'url_pattern_invalid' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'pass.altTitle' | translate}}</mat-label>
                    <input formControlName="altTitle" type="text" matInput placeholder="{{'pass.altTitle' | translate}}" data-nar="text-widget-image-alt">
                  </mat-form-field>
                  <div class="d-flex flex-row">
                    <mat-form-field appearance="outline" class="w-100 mb-2 link-field">
                      <mat-label>{{ 'pass.link-URL' | translate }}</mat-label>
                      @if (linkChip; as chip) {
                        <mat-chip-set matPrefix class="link-chip-prefix">
                          <mat-chip-row (removed)="clearLinkChip()">
                            <div class="d-flex align-items-center">
                              <mat-icon class="material-symbols-outlined chip-icon">
                                {{ chip.kind === 'child' ? 'link' : 'anchor' }}
                              </mat-icon>
                              <span class="chip-text">{{ chip.label }}</span>
                              <button matChipRemove type="button" aria-label="Remove" [disabled]="translationModeOriginal || checkDisabledField('imageLinkURL')">
                                <mat-icon class="material-symbols-outlined">close</mat-icon>
                              </button>
                            </div>
                          </mat-chip-row>
                        </mat-chip-set>
                      }
                      <input
                        matInput
                        formControlName="imageLinkURL"
                        data-nar="text-widget-image-link"
                        type="url"
                        placeholder="https://..."
                        [readonly]="!!linkChip"
                        [class.input-hidden]="!!linkChip"
                        />
                      <button
                        mat-icon-button
                        matSuffix
                        [matMenuTriggerFor]="linkMenu"
                        matTooltip="{{ 'pick_link_target' | translate }}"
                        [disabled]="translationModeOriginal || checkDisabledField('imageLinkURL')"
                        type="button"
                        >
                        <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
                      </button>
                      @if (textEditForm.controls['linkURL']?.hasError('invalidCharacters')) {
                        <mat-error>
                          {{ 'invalid_characters' | translate }}
                        </mat-error>
                      }
                      @if (textEditForm.controls['linkURL']?.hasError('pattern')
                        && !textEditForm.controls['linkURL']?.hasError('invalidCharacters')) {
                        <mat-error>
                          {{ 'url_pattern_invalid' | translate }}
                        </mat-error>
                      }
                      <mat-hint>{{ 'url_pattern_detailed' | translate }}</mat-hint>
                    </mat-form-field>
                    <input type="file" id="myfile" name="myfile" style="display: none;"(change)="readDocument($event)" #fileInput>
                    <!-- Main menu -->
                    <mat-menu #linkMenu="matMenu">
                      <ng-template matMenuContent let-button="button">
                        @if (anchorOptions?.length) {
                          <button
                            mat-menu-item
                            [matMenuTriggerFor]="anchorMenu"
                            >
                            <mat-icon class="material-symbols-outlined">anchor</mat-icon>
                            <span>{{ 'pass.linkWidgetUrl' | translate }}</span>
                          </button>
                        }
                        @if (childPages?.length) {
                          <button
                            mat-menu-item
                            [matMenuTriggerFor]="childMenu"
                            >
                            <mat-icon class="material-symbols-outlined">link</mat-icon>
                            <span>{{ 'pass.linkChildPage' | translate }}</span>
                          </button>
                        }
                        <button mat-menu-item (click)="fileInput.click()" matTooltip="{{'pass.pick' | translate}}" [disabled]="translationModeOriginal || checkDisabledField('imageUrl')">
                          <mat-icon class="material-symbols-outlined">folder_open</mat-icon>
                          <span>{{'pass.browse' | translate}}</span>
                        </button>
                      </ng-template>
                    </mat-menu>
                    <!-- Anchors submenu -->
                    <mat-menu #anchorMenu="matMenu">
                      <ng-template matMenuContent let-button="button">
                        <button mat-menu-item disabled>
                          {{ 'widgets' | translate }}
                        </button>
                        @for (a of anchorOptions; track a.id) {
                          <button
                            mat-menu-item
                            (click)="setLinkUrl(buildAnchorUrl(a))"
                            >
                            <span>{{ a.label || a.name || a.id }}</span>
                          </button>
                        }
                      </ng-template>
                    </mat-menu>
                    <!-- Child pages submenu -->
                    <mat-menu #childMenu="matMenu">
                      <ng-template matMenuContent let-button="button">
                        <button mat-menu-item disabled>
                          {{ 'pass.pageTabLabels' | translate }}
                        </button>
                        @for (c of childPages; track c.id) {
                          <button
                            mat-menu-item
                            (click)="setLinkUrl(buildChildPageUrl(c))"
                            >
                            <span>{{ c.name || c.id }}</span>
                          </button>
                        }
                      </ng-template>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (!urlData && !dynamicUrl) {
            <div [app-drag-file-browse-ui] = "dragFileData" (returnChanges)="returnChangesDragFileBrowseUI($event)"></div>
          }

        </div>
      </mat-expansion-panel>
      <div [app-widget-styling] = "{'form': textEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesStyle($event)"></div>
    </form>
  </section>

  <div [app-widget-edit-filters] = "{'form': textEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
</div>
